import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { ApiErrorInterface } from '@zaoblako/shared/common/dtos/api-error.dto';
import { MessageService } from 'primeng/api';
import type { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import type { SerdeDtoMetadataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-dto-metadata.interface';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  public constructor(private messageService: MessageService) {}

  public addCustomError(title = 'Ошибка', description = '', life = 10000) {
    this.messageService.add({ key: 'message', severity: 'error', summary: title, detail: description, life });
  }

  public addDefaultError(error: HttpErrorResponse) {
    if (error.status === 502 && error.error?.type === 'UNDER_CONSTRUCTION') {
      return this.messageService.add({
        key: 'message',
        severity: 'error',
        summary: 'Технические работы',
        detail: 'Приложение временно недоступно, идут технические работы',
        life: 10000
      });
    }

    const bodyError: ApiErrorInterface = error.error;

    if (error.status === 403) {
      return this.messageService.add({
        key: 'message',
        severity: 'error',
        summary: 'Отказано в доступе',
        detail: bodyError?.message,
        life: 10000
      });
    }

    if (error.status === 412) {
      return this.messageService.add({
        key: 'message',
        severity: 'error',
        summary: 'Ошибка',
        detail: bodyError?.message,
        life: 10000
      });
    }

    let detail: string = '';

    if (bodyError.validationErrors) {
      bodyError.validationMetadata
      if (Array.isArray(bodyError.validationErrors)) {
        bodyError.validationErrors
          .filter((validationError) => validationError)
          .forEach((validationError) => {
            detail = detail.concat(this.renderValidationErrors(validationError, bodyError.validationMetadata));
          });
      } else {
        detail = this.renderValidationErrors(bodyError.validationErrors, bodyError.validationMetadata);
      }
    }

    this.messageService.add({
      key: 'message',
      severity: 'error',
      summary: bodyError.message,
      detail: detail,
      life: 10000
    });
  }

  public addSuccessMessage(title: string = 'ОК', description: string = '', life = 10000) {
    this.messageService.add({ key: 'message', severity: 'success', summary: title, detail: description, life });
  }

  private renderValidationErrors(errors: ValidationErrorInterface<any>, metadata?: SerdeDtoMetadataInterface<any>, upName?: string): string {
    let result = '';
    const prefix = upName ? `${upName} > ` : ''

    for (const [field, error] of Object.entries(errors)) {
      if (!error) {
        continue;
      }

      const name = metadata?.[field]?.label ? `"${metadata?.[field]?.label}"` : `"${field}"`;
      if (typeof error === 'string') {
        result = `${result}${prefix}${name}: ${error}\n`
      } else if (Array.isArray(error)) {
        result = `${result}${prefix}${name}: ${error.join(', ')}\n`
      } else {
        result = this.renderValidationErrors(error, metadata?.[field]?.nested, `${prefix}${name}`)
      }
    }

    return result;
  }
}
